import { defineMessages } from 'react-intl';

export const disableClassMessages = defineMessages({
  title: {
    id: 'class-detail.enable-class.confirmation-modal.title',
    defaultMessage: `This will remove {classTitle} from ClassPass`,
  },
  titleWithReservations: {
    id: 'class-detail.enable-class.confirmation-modal.title-with-reservations',
    defaultMessage:
      'You have {numberOfReservations, plural, one {# confirmed reservation} other {# confirmed reservations}} for this class',
  },
  cancel: {
    id: 'class-detail.enable-class.confirmation-modal.cancel',
    defaultMessage: 'No, keep enabled',
  },
  accept: {
    id: 'class-detail.enable-class.confirmation-modal.accept',
    defaultMessage: 'Yes, disable class',
  },
  body: {
    id: 'class-detail.enable-class.confirmation-modal.body',
    defaultMessage:
      'Are you sure you want to disable this class on ClassPass? Your existing reservations will not be canceled, but all future availability will be disabled. <strong>This class will no longer be visible on ClassPass and you will not get any reservations from ClassPass.</strong>',
  },
});

export const disableServiceMessages = defineMessages({
  title: {
    id: 'manage-services.class-list.disable-confirmation-modal.title',
    defaultMessage: `This will remove {classTitle} from ClassPass`,
  },
  titleWithReservations: {
    id: 'manage-services.class-list.disable-confirmation-modal.title-with-reservations',
    defaultMessage: 'You have {numberOfReservations, number} confirmed reservations for this service',
  },
  cancel: {
    id: 'manage-services.class-list.disable-confirmation-modal.cancel',
    defaultMessage: 'No, keep enabled',
  },
  accept: {
    id: 'manage-services.class-list.disable-confirmation-modal.accept',
    defaultMessage: 'Yes, disable service',
  },
  body: {
    id: 'manage-services.class-list.disable-confirmation-modal.body',
    defaultMessage:
      'Are you sure you want to disable this service on ClassPass? Your existing reservations will not be canceled, but all future availability will be disabled. <strong>This service will no longer be visible on ClassPass and you will not get any reservations from ClassPass.</strong>',
  },
});
